// Page: AdminMailTemplates
// Purpose: Admin hub for managing mail templates; provides navigation to create
// flow and back to templates admin.
import React from 'react';
import { FiPlus, FiEdit3, FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const AdminMailTemplates = ({ setCurrentView }) => {
  const navigate = useNavigate();
  
  const menuItems = [
    {
      id: 'create-mail-template',
      title: 'Create Mail Template',
      description: 'Create a new mail template with front and back images',
      icon: FiPlus,
      action: () => setCurrentView('createMailTemplate')
    }
  ];

  return (
    <div className="p-6 w-full max-w-[1600px] mx-auto">
      {/* Back to Admin Dashboard button */}
      <div className="mb-4">
        <button
          onClick={() => navigate('/app/private/admin/templates')}
          className="inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
        >
          <FiArrowLeft className="w-4 h-4 mr-1.5" />
          Back to Templates Admin
        </button>
      </div>

      <div className="mb-6 flex flex-col space-y-4 sm:flex-row sm:items-center sm:justify-between sm:space-y-0">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Mail Templates</h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Create mail templates for political campaigns. To view and manage existing mail templates, use the main "Manage Templates" page and filter by "Mail".
          </p>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/app/private/manageTemplates')}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-700"
          >
            Manage Templates
          </button>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {menuItems.map((item) => {
          const IconComponent = item.icon;
          return (
            <div
              key={item.id}
              onClick={item.action}
              className="bg-white dark:bg-gray-900 rounded-lg border border-gray-300 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow duration-200 p-6 cursor-pointer hover:border-primary-300 dark:hover:border-primary-600"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-primary-100 dark:bg-primary-900/30 rounded-lg mb-4">
                <IconComponent className="w-6 h-6 text-primary-600 dark:text-primary-400" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{item.title}</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm">{item.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminMailTemplates; 